import React, { FC, ReactElement, MouseEvent } from 'react'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const RemoveIcon: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			onClick={props.onClick}
			viewBox="0 0 24 24"
			fill="none"
			className={props.className}
			width={props.width}
			height={props.height}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<path
				d="M11.57 18C17.23 18 21.13 13.43 21.13 12C21.13 10.56 17.22 6 11.57 6C5.99 6 2 10.56 2 12C2 13.43 5.98 18 11.57 18ZM11.57 16.89C6.96 16.89 3.23 12.99 3.23 12C3.23 11.17 6.96 7.11 11.57 7.11C16.16 7.11 19.91 11.17 19.91 12C19.91 12.99 16.16 16.89 11.57 16.89ZM11.57 15.92C13.75 15.92 15.5 14.14 15.5 12C15.5 9.81 13.75 8.08 11.57 8.08C9.38 8.08 7.62 9.81 7.63 12C7.64 14.14 9.38 15.92 11.57 15.92ZM11.57 13.3C10.84 13.3 10.25 12.71 10.25 12C10.25 11.28 10.84 10.7 11.57 10.7C12.29 10.7 12.88 11.28 12.88 12C12.88 12.71 12.29 13.3 11.57 13.3Z"
				fill="white"
			/>
		</svg>
	)
}

export default RemoveIcon
